module.exports = __webpack_public_path__ + "assets/img/developing.f8691806.png";